import { Loader, Stack } from '@qred/components-library';
import React from 'react';
import { useSelector } from 'react-redux';
import { ClientAssessmentQuestionnaireTypeId } from '~/enums';
import { RootState } from '~/store';
import { useGetClientAssessmentQuestionsQuery } from '~/store/apis/endpoints/clientAssessmentApi/clientAssessment.api';
import { isBelgiumClientAssessmentInSync } from './LegalQuestions.utils';
import { LegalQuestionsContent } from './components/LegalQuestionsContent';

export const LegalQuestions = () => {
  const clientId = useSelector(
    (state: RootState) => state.loanApplication.clientId
  );

  const {
    data,
    isSuccess,
    isLoading,
    isError,
  } = useGetClientAssessmentQuestionsQuery({
    typeId: ClientAssessmentQuestionnaireTypeId.LegalQuestionsBelgium,
  });

  if (!clientId) {
    throw new Error('Client ID is required to display legal questions step.');
  }

  if (isError) {
    throw new Error(
      `Failed to load Belgium client assessment for typeId: ${ClientAssessmentQuestionnaireTypeId.LegalQuestionsBelgium}`
    );
  }

  if (isSuccess && !isBelgiumClientAssessmentInSync(data)) {
    throw new Error(
      `Belgium client assessment questions are out of sync with the API response for typeId: ${ClientAssessmentQuestionnaireTypeId.LegalQuestionsBelgium}`
    );
  }

  if (isLoading) {
    return (
      <Stack justify="center" h="60%">
        <Loader />
      </Stack>
    );
  }

  return <LegalQuestionsContent clientId={clientId} />;
};
